import { PPDTracker } from '../index'
// 滚动曝光会记录 imphook-name 匹配 tgt_nameRule 的imp事件
const ppdTracker = new PPDTracker({})
// eslint-disable-next-line no-useless-escape
const EXP_MATCH_$ = /[^\{\}]+(?=\})/g
const EXP_REPLACE_ARRAY = /\[([^>]+)\]/
const POINT = function (key, param) {
    try {
        ppdTracker.track(key, param)
    } catch (e) {
        console.error(e)
    }
}
const postMessage = params => {
    if (window.self === window.top) return
    window.top.postMessage(params, '*')
}

let DATA_SET = {} // 网络数据
let PRESET_DATA = [] // 预置数据
const API_CALLBACK_LIST = [] // 网络获取数据回调列表
const TRACKER_ID = 'trackid'

export default class BaseTracker {
    constructor (activityType, options) {
        this.options = options;
        this.utilClass.listenersRouterChange()
        this.activityType = activityType
        this.handlePoint = this.handlePoint.bind(this)
        this.injectionBind()
        this.initConfig()
        this.communicatePlatform()
    }
    initConfig () {
        this.hash = '#/'
        this.pointed = [] // 单次曝光已曝光
        this.record_click_current_dom_info = null
        this.container = '' // 当前页面滚动容器
        this.exposureGapTime = 1000 // 单次曝光间隔时间
        this.clickGapTime = 500 // 单次曝光间隔时间
        this.preventDoubllePoint = {}
        this.authList = []
    }
    // 初始化与可视化埋点平台交互功能
    communicatePlatform () {
        if (this.options.hookApi) {
            this.interceptApiRequest()
        }
        if (window.self === window.top) return
        const data = sessionStorage.getItem('app-env')
        postMessage({ 'activityType': this.activityType })

        const { PPDWebUI } = window
        if (PPDWebUI) {
            const { os } = PPDWebUI
            if (os) {
                os.inApp = data == 'true'
                Object.defineProperties(PPDWebUI, {
                    'os': {
                        'configurable': true,
                        'enumerable': true,
                        'get': function () {
                            return os
                        }
                    }
                })
                postMessage({ 'inApp': os.inApp })
            }
            
        }
        
        
        PRESET_DATA = window.presetdataset = []
        this.events = [
            'open-interaction', // 开启交互
            'close-interaction', // 关闭交互，开始埋点
            'show-all-point', // 显示所有埋点
            'hide-all-point', // 隐藏所有埋点
            'iframe-loaded', // 加载完成
            'iframe-back', // 返回
            'iframe-forward', // 前进
            'open-app-env', // 开启app环境
            'close-app-env', // 关闭app环境
            'modify-network-data' // 修改网络数据
        ]
        window.addEventListener('message', event => this.dispatchMessage(event))
        this.utilClass.insertStyle()
        this.utilClass.insertListStyle()
        this.interceptClick()
    }
    interceptApiRequest () {
        require('./hookapi')
        ah.proxy({
            'onRequest': (config, handler) => {
                handler.next(config)
            },
            'onError': (err, handler) => {
                handler.next(err)
            },
            'onResponse': (response, handler) => {
                try {
                    const url = `${response.config.url}`
                        .replace(`${location.protocol}//${location.host}`, '')
                        .replace('/api/', '')
                    const mockResponse =
                        JSON.parse(sessionStorage.getItem('MOCK_DATA')) &&
                        JSON.parse(sessionStorage.getItem('MOCK_DATA'))[url]
                    response.response =
                        (mockResponse && JSON.stringify(mockResponse)) || response.response
                    handler.next(response)
                    this.authApiImpl(url, response)
                    let { dataset } = window
                    if (!dataset) {
                        dataset = {}
                    } 
                    dataset[`${url}`] = this.utilClass.checkIsJSON(response.response) ? JSON.parse(response.response) : {}
                    window.dataset = dataset
                    this.broadcastMsg(window.dataset) 
                } catch (error) {
                    handler.next(response)
                }

            }
        })
    }
    interceptClick () {
        // 拦截页面的点击事件
        window.addEventListener('click', v => this.dispatchClickEvent(v), true)
    }
    dispatchClickEvent (v) {
        if (this.stopPropagation) {
            return
        }
        const elememtId = v.target.getAttribute(TRACKER_ID)
        if (!elememtId) {
            return
        }
        v.preventDefault()
        v.stopPropagation()
        v.cancleBubble = true
        v.returnValue = false
        // 传输属性名和hook的接口数据
        postMessage({
            'element': v.target.getAttribute(TRACKER_ID),
            'loop_sign': false
        })
        // 增加点击效果
        this.selectedEffect(v)
    }
    dispatchMessage (event) {
        this.stopPropagation = false
        if (event.data instanceof Object && event.data['modify-network-data']) {
            sessionStorage.setItem(
                'MOCK_DATA',
                JSON.stringify(event.data['modify-network-data'] || {})
            )
        }
        if (event.data instanceof Object && event.data['track-config']) {
            window.trackConfig = event.data['track-config'] || {}
        }
        if (!this.events.includes(event.data)) {
            return
        }
        if (event.data === 'open-interaction') {
            this.stopPropagation = true
            if (this.currentSelectElement) {
                this.currentSelectElement.classList.remove('addClickIframeBackground')
            }
        }
        if (event.data === 'iframe-back') {
            window.history.back()
        }
        if (event.data === 'iframe-forward') {
            window.history.forward()
        }
        if (event.data === 'open-app-env') {
            sessionStorage.setItem('app-env', 'true')
        }
        if (event.data === 'close-app-env') {
            sessionStorage.setItem('app-env', 'false')
        }
        // iframe加载完成
        if (event.data === 'iframe-loaded') {
            setTimeout(() => {
                const trackidArray = this.loopChildList(document.getElementById('app').children, [])
                postMessage({
                    'trackerIdList': trackidArray
                })
                console.log('trackidArray', trackidArray.length)
            }, 2000)
            postMessage({
                'documentTitle': document.title
            })
        }

        if (event.data === 'show-all-point') {
            if (window.trackConfig) {
                this.utilClass.insertPointElementEffect('add')
            }
        } else if (event.data === 'hide-all-point') {
            if (window.trackConfig) {
                this.utilClass.insertPointElementEffect('remove')
            }
        }
    }
    // dom点击后效果
    selectedEffect (v) {
        if (this.currentSelectElement) {
            this.currentSelectElement.classList.remove('addClickIframeBackground')
        }
        this.currentSelectElement = v.target
        v.target.classList.add('addClickIframeBackground')
    }
    // 设置预置数据的值
    setPresetValue (_param) {
        if (_param) {
            PRESET_DATA[_param.key] = _param.value
            postMessage({ 'handlePresetValue': _param })
            window.presetdataset = PRESET_DATA // 通过window赋值变量完成数据变动监听，直接取值无法获取this
        }
    }
    // 注入预置数据
    injectPresetKey (params) {
        if (params instanceof Array) {
            params.forEach(_param => {
                // 默认值如果为假设置为-1
                _param.value = _param.value || -2
                PRESET_DATA[_param.key] = _param.value
                postMessage({ 'handlePresetValue': _param })
            })
        } else {
            throw new Error('injectPresetKey 的值为数组')
        }
    }
    // 订阅消息
    subscirebMsg () {
        if (!this.subscribe) {
            this.subscribe = (path, field, fn) => {
                API_CALLBACK_LIST.push({ 'key': path, 'value': fn, 'field': field })
            }
        }
    }
    // 广播消息
    broadcastMsg (value) {
        if (!(value instanceof Array)) {
            postMessage({ 'dataset': value } || '') // 通知网络数据有变动
        }
        if (API_CALLBACK_LIST.length > 0) {
            for (let i = 0; i < API_CALLBACK_LIST.length; i++) {
                const callback = API_CALLBACK_LIST[i]
                if (value instanceof Array) {
                    // 预置数据 观察是否有对应的filed字段
                    if (value.hasOwnProperty(callback.field)) {
                        callback.value.apply(this, [value])
                        API_CALLBACK_LIST.splice(i, 1)
                        break
                    }
                } else {
                    if (value.hasOwnProperty(callback.key)) {
                        callback.value.apply(this, [value])
                        API_CALLBACK_LIST.splice(i, 1)
                    }
                }
            }
        }
    }
    // 监听数据集变化
    injectionBind () {
        Object.defineProperty(window, 'dataset', {
            'set': x => {
                DATA_SET = x
                this.broadcastMsg(DATA_SET)
            },
            'get': () => {
                this.subscirebMsg()
                return DATA_SET
            }
        })
        Object.defineProperty(window, 'presetdataset', {
            'set': x => {
                PRESET_DATA = x
                this.broadcastMsg(PRESET_DATA)
            },
            'get': () => {
                this.subscirebMsg()
                return PRESET_DATA
            }
        })
    }
    // 遍历此dom下所有含有trackid的值
    loopChildList (list, array) {
        if (list.length > 0) {
            Array.prototype.forEach.call(list, child => {
                if (child.getAttribute('trackid')) {
                    array.push(child.getAttribute('trackid'))
                }
                this.loopChildList(child.children, array)
            })
        }
        // console.log('loopChildList', array)
        return array
    }

    // 手动触发埋点
    handlePoint (event, param) {
        POINT(event, {
            ...param,
            'param28': this.activityType,

        })
    }
    // 异步获取api 的值
    getApiData (apiPath, field) {
        return new Promise(resolve => {
            const apiResult = window[apiPath] || window.dataset[apiPath] // 获取预置数据or网络数据
            let timer = null
            if (!apiPath) {
                return resolve({})
            }
            if (!apiResult) {
                // 注入回调
                this.subscribe(apiPath, field, dataset => {
                    // 预置数据处理
                    if (dataset instanceof Array) {
                        clearTimeout(timer)
                        resolve(this.matchApiField(dataset, field))
                    } else {
                        // 正常数据处理
                        const data = dataset[apiPath]
                        if (data) {
                            clearTimeout(timer)
                            resolve(this.matchApiField(data, field))
                        }
                    }
                })
                timer = setTimeout(() => {
                    resolve('')
                }, 3500)
            }
            if (apiResult) {
                resolve(this.matchApiField(apiResult, field))
            }
        })
    }
    // 匹配网络数据对应的字段
    matchApiField (datas, field) {
        const filedList = field.split('.')
        if (filedList.length <= 1) {
            return datas[field]
        }
        let paramValue = null
        let dataset = datas
        for (const key of filedList) {
            // field=Content[0].awardName  ps.取json数组里面具体一个值
            const matchValue = key.match(EXP_REPLACE_ARRAY) // ["[0]","0"]
            let tmpKey = key
            if (matchValue && matchValue.length > 0) {
                tmpKey = tmpKey.replace(matchValue[0], '') // Content
                dataset = dataset[tmpKey]
                // eslint-disable-next-line prefer-destructuring
                tmpKey = matchValue[1] // 0
            }
            paramValue = dataset[tmpKey]
            dataset = paramValue
        }
        return paramValue
    }
    // 获取网络数据
    async getParamsValue (config) {
        const paramsData = JSON.parse(JSON.stringify(config))
        const wrapperParams = {}
        const { params } = paramsData
        if (params) {
            for (const paramsKey in params) {
                const paramConfig = params[paramsKey]
                // 固定值tgt_name='xxx'
                if (!paramConfig.path.includes('${') && !paramConfig.path.includes('.')) {
                    wrapperParams[paramsKey] = paramConfig.path
                    continue
                }
                // 动态值${matchValue}
                // eslint-disable-next-line prefer-destructuring
                const matchValue = paramConfig.path.match(EXP_MATCH_$)[0]
                // 获取网络库数据&预置数据
                const paramValue = await this.getApiData(paramConfig.apiPath, matchValue)
                wrapperParams[paramsKey] = paramValue
            }
        }
        return wrapperParams
    }
    authApiImpl (url, response) {
        let existUrl = false
        console.log('tag', this.authList)
        for (const item of this.authList) {
            if (url.indexOf(item) !== -1) {
                existUrl = true
                break
            }
        }
        if (!existUrl) return
        this.handlePoint('h5_auth', {
            'page': `super-${document.title}`,
            'auth_tgt': 'super_resultMsg',
            'auth_tgt_name': 'super-接口响应',
            'param1': `${JSON.parse(response.response).Result}`,
            'param': `${url}`,

        })
    }
    get utilClass () {
        return {
            isWeixin () {
                const ua = window.navigator.userAgent.toLowerCase()
                if (ua.match(/micromessenger/i) == 'micromessenger') {
                    return true
                } else {
                    return false
                }
            },
            getQueryString (name) {
                const after = decodeURIComponent(
                    window.location.hash.split('?')[1] || window.location.search.split('?')[1]
                )
                if (after) {
                    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
                    const r = after.match(reg)
                    if (r != null) {
                        return decodeURIComponent(r[2])
                    } else {
                        return null
                    }
                }
            },
            getUrlParams (name) {
                const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
                const r = window.location.search.substr(1).match(reg)
                if (r != null) return r[2]
                return null
            },
            sleep (time) {
                return new Promise(resolve => {
                    setTimeout(() => {
                        resolve(true)
                    }, time)
                })
            },
            runScript (url) {
                return new Promise((resolve, reject) => {
                    const script = document.createElement('script')
                    script.src = url
                    script.onload = resolve
                    script.onerror = reject
                    // const firstScript = document.getElementsByTagName('script')[0];
                    // firstScript.parentNode.insertBefore(script, firstScript);
                    if (!document.body) {
                        reject('document.body 为null')
                        return
                    }
                    document.body.appendChild(script)
                })
            },

            // 注入style
            insertStyle () {
                // 自动增加css
                const style = document.createElement('style')
                style.type = 'text/css'
                style.appendChild(
                    document.createTextNode(
                        ' .pointElementBg{ background:#ff009df2!important;border:solid 2px green}.addClickIframeBackground{background:#3c9f8c!important;border:solid 2px red}'
                    )
                )
                document.getElementsByTagName('head')[0].appendChild(style)
            },

            insertListStyle () {
                // 自动增加css
                const style = document.createElement('style')
                style.type = 'text/css'
                // style.appendChild(document.createTextNode('.list_Class_track{background:black!important;border:solid 9px black}'));
                // document.getElementsByTagName('head')[0].appendChild(style);
            },
            // 埋点元素增加效果
            insertPointElementEffect (_status) {
                if (window.trackConfig) {
                    const pointElements = [
                        ...Object.keys(window.trackConfig.imp),
                        ...Object.keys(window.trackConfig.click)
                    ]
                    if (pointElements.length) {
                        for (const element of pointElements) {
                            const elementTarget = document.querySelector(
                                `[${TRACKER_ID}="${element}"]`
                            )
                            elementTarget &&
                                elementTarget.classList &&
                                elementTarget.classList[_status]('pointElementBg')
                        }
                    }
                }
            },
            checkIsJSON (str) {
                if (typeof str == 'string') {
                  try {
                    var obj = JSON.parse(str);
                    if (typeof obj == 'object' && obj) {
                      return true;
                    } else {
                      return false;
                    }
                  } catch (e) {
                    return false;
                  }
                }
                return false;
            },
            isHidden (el) {
                if (el) {
                    return (el.offsetParent === null)
                } else {
                    return true
                }
            },
            listenersRouterChange () {
                window.addEventListener('popstate', function(event) {
                    this.domChangeArray = [];
                })
                window.addEventListener('hashchange',function(event){
                    this.domChangeArray = [];
                })
                window.addEventListener('pushState', function(e) {
                    this.domChangeArray = [];
                });
                window.addEventListener('replaceState', function(e) {
                    this.domChangeArray = [];
                });
            },
            debounce (func, wait, immediate = true) {
                let timeout, result
                const later = (context, args) =>
                    setTimeout(() => {
                        timeout = null
                        if (!immediate) {
                            result = func.apply(context, args)
                            context = args = null
                        }
                    }, wait)
                const debounced = function (...params) {
                    if (!timeout) {
                        timeout = later(this, params)
                        if (immediate) {
                            result = func.apply(this, params)
                        }
                    } else {
                        clearTimeout(timeout)
                        timeout = later(this, params)
                    }
                    return result
                }
                debounced.cancel = function () {
                    clearTimeout(timeout)
                    timeout = null
                }
                return debounced
            }
        }
    }
}
